module.exports = __webpack_public_path__ + "assets/Theft.00398fd1.svg";